import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb'
import HRList from './HRList/HRList'
import ApplicationList from './ApplicationList/ApplicationList'
import './EngagementDetails.scss'
import DevOpsModal from '@/components/devops/DevModal'
import { useParams, useSearchParams } from 'react-router-dom'
import { useLazyGetEngagementQuery } from '@/features/Client/clientApi'

export default function EngagementDetails() {
  const currentEngagement = useSelector(
    (state: any) => state.clientCard.currentEngagement,
  )
  const [searchParams] = useSearchParams()  
  const { engagementId } = useParams<{ engagementId: string }>()
  const [ getEngagement ] = useLazyGetEngagementQuery()

  useEffect(() => {
    const id = currentEngagement.engagementID
    if (id === '' && engagementId) {
      getEngagement(engagementId)
    }
  }, [])

  useEffect(() => {
    if (searchParams.get('showDev') === 'true') {
      setIsModalOpen(false)
    }
  }, [searchParams])

  const breadcrumbItems = [
    {
      text: 'Home',
      url: '/',
      blockNavigation: false,
    },
    {
      text: currentEngagement.engagementName,
      disabled: true,
    },
  ]

  if (!currentEngagement) {
    return <div>Loading...</div> // Handle loading state
  }

  const [isModalOpen, setIsModalOpen] = useState(true)

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const handleNext = (selectedOption: string) => {
    console.log('Next clicked with option:', selectedOption)
  }

  return (
    <div className="motif-container no-gutters">
      <div className="motif-col-lg-12  main-container">
        <Breadcrumb items={breadcrumbItems} ariaLabel="Breadcrumb navigation" />
        <HRList />
      </div>
      <div className="motif-col-lg-12 application-container">
        <ApplicationList />
      </div>

      <DevOpsModal
        isOpen={isModalOpen}
        setISOpen={setIsModalOpen}
        nextBtnHandler={handleNext}
        backBtnHandler={handleCancel}
      />
    </div>
  )
}

